import { haveAnyValue } from 'src/utils/utilitiesV2'

/**
 * Normaliza los elementos seleccionados en la tabla de órdenes: cuando un
 * elemento envuelve la orden en su propiedad `item`, devuelve dicha orden;
 * de lo contrario devuelve el elemento tal cual.
 */
const normalizeSelectedItems = <T extends { item?: unknown }>(selected: T[]): T[] => {
  if (!haveAnyValue(selected)) return selected
  return selected.map(s => (haveAnyValue(s?.item) ? (s.item as T) : s))
}

export { normalizeSelectedItems }
